import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'
import {doPROJECT_SET, doREQUEST_ERROR, doREQUEST_COMPLETE, doPENDING_REQUEST_DELETE, doREQUEST_SKIP} from '../state'
import {checkRequestPending} from './check_pending_request'
import {getToken} from './token_fetcher'

export const REQUEST_PROJECT_FETCH = 'REQUEST_PROJECT_FETCH'
export const doREQUEST_PROJECT_FETCH = createDoRequestAction(REQUEST_PROJECT_FETCH)

export const requestProjectFetchActionCreators = {
  doREQUEST_PROJECT_FETCH,
}

export function* requestProjectFetch({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestProjectFetch')

  const sameRequestPending = yield call(checkRequestPending, REQUEST_PROJECT_FETCH, payload)
  if (sameRequestPending === true) {
    return yield put(
      doREQUEST_SKIP({
        fromType: REQUEST_PROJECT_FETCH,
        requestId: payload.requestId,
      }),
    )
  }

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    yield put(doPENDING_REQUEST_DELETE({requestType: REQUEST_PROJECT_FETCH, requestId: payload.requestId}))

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectId} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/project-fetch`,
    accessToken,
    data: {
      projectId,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    yield put(doPENDING_REQUEST_DELETE({requestType: REQUEST_PROJECT_FETCH, requestId: payload.requestId}))

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/project-fetch',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doPROJECT_SET(result.payload))

  yield put(doPENDING_REQUEST_DELETE({requestType: REQUEST_PROJECT_FETCH, requestId: payload.requestId}))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_FETCH,
        requestId: payload.requestId,
        ...result.payload,
      },
      setRequestResult,
    ),
  )
}

export function* projectFetchSaga() {
  yield takeEvery(REQUEST_PROJECT_FETCH, requestProjectFetch)
}
